import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import jsp from "../Assets/js_p.png";
import memory from "../Assets/TravelMemory.png";
import BackButton from "../componets/BackButton";



export const MemoryMatch = () => {
        const handleWebButtonClick = () => {
    window.location.href = "https://susanalab.github.io/Travel-memory-game/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/CDMX011-memory-match"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>Travel Memory </h1>
     
      <div className="proyect-description">
        <p>
        Construction project of a web version of the Memory Match game, in which a player can play alone, in the browser
        </p>
      </div>
      <div className="proyect-buttons">
        <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
        <img src={jsp} alt="JavaScript" className="computer" />
      </div> </div>
      <img
        src={memory}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};

